module.exports = __webpack_public_path__ + "img/熙之.958cc12.png";